import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import FeedbackWidget from '@/components/feedback/FeedbackWidget';
import { useAuthStore } from '@/stores/auth-store';
import { LogOut, UserCheck } from 'lucide-react';

import Footer from './footer';
import Navbar from './navbar';

// Privacy extensions may block this module by URL. Keep that failure outside
// the application's startup graph; no consent is granted and analytics stay off.
const CookieConsentBanner = lazy(() =>
  import('@/components/cookie-consent-banner').catch(() => ({ default: () => null })),
);

function ImpersonationBanner() {
  const isImpersonating = useAuthStore(s => s.isImpersonating);
  const user = useAuthStore(s => s.user);
  const stopImpersonation = useAuthStore(s => s.stopImpersonation);

  if (!isImpersonating || !user) return null;

  return (
    <div className='bg-amber-500 text-white px-4 py-2 flex items-center justify-between gap-4 text-sm font-medium z-50'>
      <span className='flex items-center gap-2'>
        <UserCheck className='h-4 w-4 shrink-0' />
        Mode test — vous naviguez en tant que{' '}
        <strong>
          {user.firstName} {user.lastName}
        </strong>{' '}
        ({user.role})
      </span>
      <button
        onClick={() => void stopImpersonation()}
        className='flex items-center gap-1.5 rounded bg-white/20 px-3 py-1 hover:bg-white/30 transition-colors whitespace-nowrap'
      >
        <LogOut className='h-3.5 w-3.5' />
        Quitter
      </button>
    </div>
  );
}

export default function Layout() {
  return (
    <div className='min-h-screen flex flex-col overflow-x-clip'>
      <ImpersonationBanner />
      <Navbar />
      <main className='flex flex-col w-full max-w-full m-auto'>
        <Outlet />
      </main>
      <Footer />
      <FeedbackWidget />
      <Suspense fallback={null}>
        <CookieConsentBanner />
      </Suspense>
    </div>
  );
}
